import * as Sentry from "@sentry/solid"
import posthog from "posthog-js"

const isDev = window.location.host.includes("dev.fika.bar")

if (!isDev) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    // TODO: DRY
    release: `fika-app@${import.meta.env.WORKERS_CI_COMMIT_SHA}`,
    integrations: [],
  })

  const searchParams = new URLSearchParams(window.location.search)
  const distinctId = searchParams.get("distinctId")
  const sessionId = searchParams.get("sessionId")

  const apiHost = "https://brew.fika.bar"

  const config = {
    api_host: apiHost,
    ui_host: "https://eu.posthog.com",
    persistence: "cookie" as const,
    defaults: "2025-05-24" as const,
    session_recording: {
      maskAllInputs: false,
      maskInputOptions: { password: true },
    },
    bootstrap: undefined as
      | { sessionID: string; distinctID: string }
      | undefined,
  }

  if (sessionId && distinctId) {
    config.bootstrap = {
      sessionID: sessionId,
      distinctID: distinctId,
    }
  }

  posthog.init(import.meta.env.VITE_POSTHOG_ID, config)
}

export function identifyUser(user: {
  id: string
  name: string | null
  email: string
}) {
  if (isDev) {
    return
  }
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name ?? undefined,
  })
  posthog.identify(user.id, { email: user.email, name: user.name })
  posthog.reloadFeatureFlags()
}

export function captureEvent(event: string, properties: Record<string, any>) {
  if (isDev) {
    return
  }

  posthog.capture(event, properties)
  dataLayer.push({ event, properties })
}
